import "./Forecast.css";

import { DateTime } from "luxon";
import React from "react";

import cloudPNG from "../../images/cloud.png";
import partcloudPNG from "../../images/partcloud.png";
import rainPNG from "../../images/rain.png";
import snowPNG from "../../images/snow.png";
import stormPNG from "../../images/storm.png";
import sunPNG from "../../images/sun.png";
import { temperatureFormat, windFormat } from "../../utils";

const getIcon = (forecast) => {
  if (["Rain", "Drizzle"].includes(forecast.desc)) return rainPNG;

  if (forecast.desc === "Snow") return snowPNG;

  if (forecast.desc === "Thunderstorm") return stormPNG;

  if (forecast.c < 5) return sunPNG;

  if (forecast.c < 50) return partcloudPNG;

  return cloudPNG;
};

const Forecast = ({ data, metric, timezone }) => {
  if (!data) return null;

  return (
    <div className="forecastcontainer">
      <div>
        <h2>5 Day Forecast</h2>
      </div>
      <div className="forecastholder">
        {data.map((forecast, i) => (
          <div className="forecaststat" key={i}>
            <h4>
              {DateTime.fromISO(forecast.dt)
                .setZone(timezone)
                .toLocaleString(DateTime.DATE_MED)}
            </h4>
            <img alt="" src={getIcon(forecast)} />
            <br />
            {forecast.desc}
            <br />
            Max: {temperatureFormat(forecast.tmax, metric)} <br />
            Min: {temperatureFormat(forecast.tmin, metric)} <br />
            {windFormat(forecast.ws, forecast.wd, metric)}
            <h3>
              {DateTime.fromISO(forecast.dt).setZone(timezone).toFormat("cccc")}
            </h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Forecast;
